export default {
	name: 'consumption',
	path: '/consumption',
	redirect: '/consumption/statistics',
	meta: {
		title: 'consumption_system',
		icon: 'icon-consumption'
	},
	children: [
		{
			name: 'statistics',
			path: 'statistics',
			fullPath: '/consumption/statistics',
			meta: {
				title: '统计报表',
				icon: 'icon-consumption-statistics'
			},
			component: () =>
				import(/*webpackChunkName: "consumption-statistics"*/ '@/views/consumption/statistics')
		},
		{
			name: 'account',
			path: 'account',
			fullPath: '/consumption/account',
			meta: {
				title: 'consumption_account',
				icon: 'icon-consumption-account'
			},
			component: () =>
				import(/*webpackChunkName: "consumption-account"*/ '@/views/consumption/account')
		},
		// 商户管理
		{
			name: 'merchant',
			path: 'merchant',
			fullPath: '/consumption/merchant',
			meta: {
				title: 'consumption_merchant',
				icon: 'icon-consumption-merchant'
			},
			component: () =>
				import(/*webpackChunkName: "consumption-merchant"*/ '@/views/consumption/merchant')
		}
	]
};
